// import React from 'react';
// import PropTypes from 'prop-types';
// import Autosuggest from 'react-autosuggest';
// import match from 'autosuggest-highlight/match';
// import parse from 'autosuggest-highlight/parse';
// import TextField from '@material-ui/core/TextField';
// import Paper from '@material-ui/core/Paper';
// import MenuItem from '@material-ui/core/MenuItem';
// import { withStyles } from '@material-ui/core/styles';
//
// function renderInput(inputProps) {
//   const { classes, ref, ...other } = inputProps;
//
//   return (
//     <TextField
//       fullWidth
//       inputRef={ref}
//       InputProps={{
//         classes: {
//           input: classes.input,
//         },
//         ...other,
//       }}
//     />
//   );
// }
//
// const getDefaultLabel = (suggestion) => suggestion.name;
//
// const renderDefaultSuggestion = (getLabel) => (suggestion, { query, isHighlighted }) => {
//   const matches = match(getLabel(suggestion), query);
//   const parts = parse(getLabel(suggestion), matches);
//
//   return (
//     <MenuItem selected={isHighlighted} component="div">
//       <div>
//         {parts.map((part, index) => {
//           return part.highlight ? (
//             <span key={String(index)} style={{ fontWeight: 300 }}>
//               {part.text}
//             </span>
//           ) : (
//             <strong key={String(index)} style={{ fontWeight: 500 }}>
//               {part.text}
//             </strong>
//           );
//         })}
//       </div>
//     </MenuItem>
//   );
// };
//
// function renderSuggestionsContainer(options) {
//   const { containerProps, children } = options;
//
//   return (
//     <Paper {...containerProps} square>
//       {children}
//     </Paper>
//   );
// }
//
// const styles = theme => ({
//   container: {
//     flexGrow: 1,
//     position: 'relative',
//   },
//   suggestionsContainerOpen: {
//     position: 'absolute',
//     marginTop: theme.spacing.unit,
//     marginBottom: theme.spacing.unit * 3,
//     left: 0,
//     right: 0,
//     // zIndex: 50000,
//   },
//   suggestion: {
//     display: 'block',
//   },
//   suggestionsList: {
//     margin: 0,
//     padding: 0,
//     listStyleType: 'none',
//   },
// });
//
// class AutoComplete extends React.Component {
//   state = {
//     suggestions: [],
//     text: '',
//   };
//
//   componentWillMount() {
//     const { value } = this.props;
//     if (value) {
//       this.setState({
//         suggestion: value,
//         value: (this.props.getSuggestionLabel || getDefaultLabel)(value),
//       });
//     }
//   }
//
//   componentWillReceiveProps(nextProps) {
//     const { value } = nextProps;
//     if (value && value !== this.state.value) {
//       this.setState({
//         suggestion: value,
//         value: (this.props.getSuggestionLabel || getDefaultLabel)(value),
//       });
//     }
//   }
//
//   handleSuggestionsFetchRequested = ({ value, reason, ...other }) => {
//     console.log('handleSuggestionsFetchRequested', value, other);
//     if (reason !== 'suggestion-selected') {
//       this.props.fetchSuggestions(value).then((suggestions) => {
//         this.setState({
//           suggestions,
//         });
//       });
//     }
//
//     this.props.onChange(value, false);
//   };
//
//   handleSuggestionsClearRequested = () => {
//     this.setState({
//       suggestions: [],
//     });
//   };
//
//   handleChange = (event, { newValue, method }, ...other2) => {
//     console.log('handleChange', newValue, method, other2);
//     this.setState({
//       text: newValue, // method === 'type' ? newValue : newValue.name,
//     });
//   };
//
//   render() {
//     const {
//       classes, placeholder, onChange, getSuggestionLabel, alwaysRenderSuggestions,
//       shouldRenderSuggestions, renderSuggestion
//     } = this.props;
//
//     return (
//       <Autosuggest
//         theme={{
//           container: classes.container,
//           suggestionsContainerOpen: classes.suggestionsContainerOpen,
//           suggestionsList: classes.suggestionsList,
//           suggestion: classes.suggestion,
//         }}
//         renderInputComponent={renderInput}
//         suggestions={this.state.suggestions}
//         onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
//         onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
//         onSuggestionSelected={(evt, { suggestion }) => onChange(suggestion, true)}
//         renderSuggestionsContainer={renderSuggestionsContainer}
//         getSuggestionValue={getSuggestionLabel || getDefaultLabel}
//         renderSuggestion={renderSuggestion || renderDefaultSuggestion(getSuggestionLabel || getDefaultLabel)}
//         inputProps={{
//           classes,
//           placeholder,
//           value: this.state.text,
//           onChange: this.handleChange,
//         }}
//         fullWidth
//         alwaysRenderSuggestions={alwaysRenderSuggestions}
//         shouldRenderSuggestions={shouldRenderSuggestions}
//       />
//     );
//   }
// }
//
// AutoComplete.propTypes = {
//   classes: PropTypes.object.isRequired,
//   fetchSuggestions: PropTypes.func.isRequired,
//   value: PropTypes.any,
//   onChange: PropTypes.func.isRequired,
//   getSuggestionLabel: PropTypes.func,
//   getSuggestionValue: PropTypes.func,
//   // renderSuggestion: PropTypes.func,
// };
//
// export default withStyles(styles)(AutoComplete);


// WEBPACK FOOTER //
// ./src/components/Common/AutoComplete/index.js